import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import styles from "./AppointmentModal.module.css";
import Typography from "@mui/material/Typography";
import { UniversalContext } from "../../../context/UniversalContext/UniversalContext";
import { Alert, Button, IconButton, MenuItem, Snackbar, TextField } from "@mui/material";
import { CancelPresentation } from "@mui/icons-material";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "40%",
    bgcolor: "background.paper",
    borderRadius: "1rem ",
    boxShadow: "1px 1px 1rem grey",
    p: 4,
    '@media screen and (max-width: 500px)': {
        width: "90%",
    }
};

const categories = [
    { name: "", services: [] },
]

export default function AppointmentModal() {
    const { appointmentModal, setAppointmentModal, setAlert } = React.useContext(UniversalContext);
    const [name, setName] = React.useState("");
    const [mobileNumber, setMobileNumber] = React.useState("");
    const [address, setAddress] = React.useState("");
    const [need, setNeed] = React.useState("");
    const [buttonVariant, setButtonVariant] = React.useState("disabled");
    function handleClose() { setAppointmentModal(false); }
    const open = appointmentModal;
    React.useEffect(() => {
        if (name && mobileNumber && address && need) {
            setButtonVariant("contained");
        }
        else {
            setButtonVariant("disabled");
        }
    }, [
        name,
        mobileNumber,
        address,
        need
    ])

    const formSubmitHandler = (e) => {
        e.preventDefault();
        console.log("Form submitted");
        console.log(name, mobileNumber, address, need);
        handleClose();
        setAlert(true);
        setTimeout(() => {
            setAlert(false);
        }, 6000);
    }

    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={open}
            onClose={handleClose} // Pass a function to the onClose prop
            closeAfterTransition

            slots={{ backdrop: Backdrop }}
            slotProps={{
                backdrop: {
                    timeout: 500,
                },
            }}
        >
            <Fade in={open}>
                <Box sx={style} className={styles.box}>
                    <div className={styles.flexRow}>
                        <h2 style={{ fontWeight: "bold" }}>Book Appointment</h2>
                        <IconButton
                            color="error"
                            aria-label="add to shopping cart"
                            onClick={handleClose}
                        >
                            <CancelPresentation />
                        </IconButton>
                    </div>
                    <Typography
                        id="transition-modal-description"
                        sx={{ mt: 2 }}
                        className={styles.flexCol}
                    >
                        <form className={styles.form} onSubmit={formSubmitHandler}>
                            <TextField
                                className={styles.normalInput}
                                required
                                color="success"
                                id="outlined-required"
                                label="Name"
                                fullWidth
                                defaultValue=""
                                onChange={(e) => setName(e.target.value)}
                            />
                            <TextField
                                className={styles.normalInput}
                                type="tel"
                                color="success"
                                required
                                id="outlined-required"
                                label="Mobile Number"
                                fullWidth
                                defaultValue=""
                                onChange={(e) => setMobileNumber(e.target.value)}
                            />
                            <TextField
                                className={styles.normalInput}
                                required
                                color="success"
                                id="outlined-required"
                                label="Address"
                                fullWidth
                                defaultValue=""
                                onChange={(e) => setAddress(e.target.value)}
                            />
                            <TextField
                                id="outlined-select-currency"
                                color="success"
                                select
                                label="Select your need"
                                fullWidth
                                defaultValue=""
                                helperText="What do you want to book?"
                                onChange={(e) => setNeed(e.target.value)}
                            >
                                <MenuItem key="appointment" value="appointment">
                                    Appointment with Specialist
                                </MenuItem>
                                <MenuItem key="services" value="Services">
                                    Be an AyurHom Partner
                                </MenuItem>
                            </TextField>
                            <Button variant={buttonVariant} type="submit" size="large" color="success" className={styles.modalButton}>Book Now</Button>
                        </form>
                    </Typography>
                </Box>
            </Fade>
        </Modal>
    );
}
